module.exports = __webpack_public_path__ + "assets/img/vp.24199adc.gif";